<template>
  <v-card tile>
    <v-card-title class="text-xs-center">
      <v-icon medium color="orange darken-2" class="mr-1">fas fa-envelope</v-icon>
      <span class="subheading">各学院按项目类别到款统计（万元）</span>
      <v-spacer/>
      <v-btn
        flat
        @click="more = !more"
      >
        更多
      </v-btn>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :loading="loading"
      hide-actions
      item-key="dbid"
      :disable-initial-sort="true"
      :items="more? items: items.slice(0, 10)"
      no-data-text="没有数据。"
      no-results-text="没有符合条件的记录。"
    >
      <template slot="items" slot-scope="props">
        <td>
          {{ props.index + 1}}
        </td>
        <td>{{props.item.name}}</td>
        <td>{{props.item.research_amount}}</td>
        <td>{{props.item.devele_amount}}</td>
        <td>{{props.item.all_amount}}</td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
  const uri = '/api/proj/report/college-project-statistics';
  export default {
    props: ["startDate", "endDate","deptId"],
    name: "CollegeProjectStatistics",
    data() {
      return {
        more: false,
        loading: false,
        items: [],
        // 表头
        headers: [
          {text: '#', align: 'left', sortable: false, value: 'dbid', width: "2rem"},
          {text: '学院名称', align: 'left', sortable: true, value: 'name'},
          {text: '纵向项目', align: 'left', sortable: true, value: 'research_amount'},
          {text: '横向项目', align: 'left', sortable: true, value: 'devele_amount'},
          {text: '合计', align: 'left', sortable: true, value: 'all_amount'}
        ]
      }
    },
    watch: {
      "startDate": 'get',
      "endDate": 'get',
      "deptId": 'get'
    },
    created() {
      this.get();
    },
    mounted() {
    },
    computed: {},
    methods: {
      get() {
        if (this.loading || !this.startDate || !this.endDate) {
          return
        }
        this.loading = true;
        let params = {"incomeDateStart": this.startDate, "incomeDateEnd": this.endDate,"deptId":this.deptId};
        this.axios.get(uri, {params: params}).then(
          rsp => {
            this.items = rsp.data;
            this.loading = false;
          })
      }
    }
  }
</script>

<style scoped>

</style>
